import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { ReactComponent as Edit } from "../../../../resources/images/Write.svg";
import { contactsTypesActions } from "../../../../store/contactTypes/contactTypesActions";
import { useDispatch } from "react-redux";
import Loader from "../../../../components/common/Loader";

import { Delete, } from "../../LeftNav/SvgIcons";
import { toast } from "react-toastify";
import ContactTypesList from "./ContactTypesList";
import ContactTypesFilters from "./ContactTypesFilters";
import { Pagination } from "../../../../components/common";
import { DeleteContactTypeModal } from "./Modals/DeleteContactTypePopup";
import { TooltipDescription } from "../../../../components/common/Modal/AssetsModals";
import TagsOverlay from "../ConversationsRevamp/TagsOverlay";

const ordersList = [
  { id: 1, value: "Ascending" },
  { id: 0, value: "Descending" },
];

export default function ContactTypes() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [paginationResponse, setPaginationResponse] = useState({
    currentCount: 0,
    totalRecords: 0,
  });
  const [isLoading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrderBy] = useState({
    orderByKey: "Id",
    orderVal: null,
  });

  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isListView, setIsListView] = useState(false);
  const [contactGrid, setContactGrid] = useState([]);
  const [allContactArea, setAllContactArea] = useState([]);
  const [allOfishRoles, setAllOfishRoles] = useState([]);
  const [filterModel, setFilters] = useState({
    search: "",
    ofishRole: "",
    contactArea: "",
    status: "",
  });

  const [isFilterApplied, setIsFilterApplied] = useState(false);

  const getAllOfishRole = () => {
    dispatch(contactsTypesActions.onGetAllOfishRoles()).then(response => {
      if (response?.data.success) {
        setAllOfishRoles(response.data.data);
      }
    });
  };

  const getAllContactArea = () => {
    dispatch(contactsTypesActions.onGetAllContactAreas()).then(response => {
      if (response?.data.success) {
        setAllContactArea(response.data.data);
      }
    });
  };

  const gridDataLoad = useCallback(() => {
    setLoading(true);
    const modal = {
      name: filterModel.search,
      ofishRole: filterModel.ofishRole,
      contactArea: filterModel.contactArea,
      status: filterModel.status,
      pagination: {
        pageSize: rowsPerPage,
        pageNo: page,
        orderByKey: order.orderByKey,
        orderByVal: order.orderVal ?? 0,
      },
    };
    dispatch(contactsTypesActions.onGetAllContactTypes(modal)).then(data => {
      if (data?.data?.success) {
        setContactGrid(data?.data?.data?.data);
        setPaginationResponse(data?.data?.data?.pagination)
      }
      setLoading(false);
    });
  }, [
    dispatch,
    filterModel.search,
    filterModel.status,
    filterModel.ofishRole,
    filterModel.contactArea,
    order.orderByKey,
    order.orderVal,
    page,
    rowsPerPage
  ]);

  useEffect(() => {
    dispatch(contactsTypesActions.onChange("dataField", []));
    dispatch(contactsTypesActions.onChange("dataModule", []));
    dispatch(contactsTypesActions.onChange("dataConnection", []));
    getAllOfishRole();
    getAllContactArea();
  }, []);

  useEffect(() => {
    gridDataLoad();
  }, [
    gridDataLoad,
    filterModel.search,
    filterModel.status,
    filterModel.ofishRole,
    filterModel.contactArea,
    order.orderByKey,
    order.orderVal,
    page,
    rowsPerPage
  ]);

  const deleteContactType = () => {
    setLoading(true);
    dispatch(contactsTypesActions.onDeleteContactType(itemToDelete.id))
      .then(data => {
        setLoading(false);
        if (data?.data?.success) {
          toast.success(`${itemToDelete.nameSingularInternal} is deleted successfully!`);
          setItemToDelete(null);
          gridDataLoad();
        } else if (!data?.data?.success && data?.data?.message) {
          toast.error(data?.data?.message);
          setItemToDelete(null);
        }
      })
      .catch(error => {
        setLoading(false);
        toast.error(error);
      })

  };

  return (
    <div
      className='gridBody contentBody businessCustomerGrid'
      style={{ paddingRight: "20px !important" }}
    >
      <ContactTypesFilters
        AppliedFilters={filterModel}
        onApplyFilters={(filters, isFilterApplied) => {
          setFilters(filters);
          setIsFilterApplied(!isFilterApplied);
        }}
        ActiveTabId={1}
        setActiveTabId={() => { console.log('Testing Tabs') }}
        isListView={isListView}
        onToggleListView={setIsListView}
        ordersList={ordersList}
        order={order}
        setOrderBy={setOrderBy}
        allContactArea={allContactArea}
        allOfishRoles={allOfishRoles}
      />
      {isLoading ? <Loader /> : null}
      <h2 className='gridInnerHeading'>
        <span>All Contact Types</span>
        <span className='gridTopPagination'>
          <Pagination
            recordCount={paginationResponse?.totalRecords}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            rowsPerPageOptions={[]}
            backIconButtonProps={{ style: { display: "none" } }}
            nextIconButtonProps={{ style: { display: "none" } }}
          />
        </span>
      </h2>
      {!isListView ? <Grid container spacing={1} sx={{ width: "100%" }}>
        {contactGrid.length === 0 && (
          <h4 className='noRecordFound'>
            Uh Oh! You have not created any contact types yet!
          </h4>
        )}
        {contactGrid.map(item => {
          return (
            <Grid item xs={12} sm={12} md={4}>
              <div className='contactTypesGrid'>
                <div className='editSection'>
                  <i style={{
                    marginRight: '10px',
                    cursor: 'pointer'
                  }}
                    onClick={() => {
                      setItemToDelete(item);
                      setIsDeleteModal(true)
                    }}>
                    <Delete />
                  </i>
                  <Edit
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push("/new-contact-types?id=" + item.id);
                    }}
                  />
                </div>
                <p className='contactTypeTitle'>
                  {/* {item.nameSingularInternal} */}
                  <TooltipDescription
                    title={<TagsOverlay
                      title="Contact Type Name"
                      noChipText="No Message Found"
                      tags={[]}
                      text={item.nameSingularInternal ?? ""}
                    />}
                    placement={"bottom"}>
                    <span>
                      {item.nameSingularInternal ? item.nameSingularInternal.length <= 20 ? item.nameSingularInternal : `${item.nameSingularInternal.substring(0, 19)}...` : "--"}
                    </span>
                  </TooltipDescription>
                  {item?.status === 1 ? (
                    <>
                      <span style={{ color: "red" }}>*</span>
                      <span
                        style={{
                          marginLeft: "10px",
                          height: "15px",
                          width: "15px",
                          background: "#50CD89",
                          borderRadius: "50%",
                          display: "inline-block",
                        }}></span>
                    </>
                  ) : (
                    <span
                      style={{
                        marginLeft: "10px",
                        height: "15px",
                        width: "15px",
                        background: "#FFC84A",
                        borderRadius: "50%",
                        display: "inline-block",
                      }}></span>
                  )}
                </p>
                <p className='contactTypeCustomer'>{item.contactAreaName}</p>
                <div className='contactAmount'>
                  <p className='amount'>{item.contactCounts}</p>
                  <p className='contact'>Contacts</p>
                </div>
              </div>
            </Grid>
          );
        })}
      </Grid> :
        (
          <ContactTypesList
            contactTypesData={contactGrid}
            onDeleteContactType={(contactType) => {
              setItemToDelete(contactType);
              setIsDeleteModal(true);
            }}
            onEditContactType={(item) => { history.push("/new-contact-types?id=" + item.id); }}
            order={order}
            onOrderBy={setOrderBy}
          />
        )}
      <Pagination
        recordCount={paginationResponse.totalRecords}
        page={page - 1}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
      {itemToDelete && <DeleteContactTypeModal
        open={isDeleteModal}
        onClose={() => {setIsDeleteModal(false)}}
        onDeleteContactType={deleteContactType}
        contactType={itemToDelete}
      />}
    </div>
  );
}
